import RosterQrCodesPrintItem from './RosterQrCodesPrintItem';

export default RosterQrCodesPrintItem;
